export function isNominationWithTranscriptionRequired(nomination) {
    return nomination.type === 'DEFILE' && (nomination.params?.maxParticipants || 100) < 4;
}

export function isNominationWithTranscriptionNeeded(nomination) {
    return nomination.type === 'DEFILE' && (nomination.params?.minParticipants || 0) < 4;
}

export function isTranscriptionRequired(value) {
    return value && value.match(/[a-zA-Z]/);
}